import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeRecordLocatorCommand extends BaseCommand {
  CommandName = "ChangeRecordLocator";
  Command: {
    NewRecordLocator: string;
  };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { NewRecordLocator: value };
  }
}
